import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { FC } from "react";
import Image from "next/image";
import styles from "../../../styles/home/Home.module.scss";
import locationSvg from "../../../utils/svg-icon/location";

const HomeHeadDetailDesktop: FC = () => {
    const { Italy } = locationSvg;
    return (
        <MDBRow center>
            <MDBCol
                className={`${styles.headRowCardContainer} bg-white rounded-9`}
            >
                <MDBRow className={`${styles.headCardContainer} py-4`}>
                    <MDBCol size={12} md={4} className="px-4 px-lg-5">
                        <div
                            className={`d-flex flex-column align-items-center text-center ${styles.headCardContent}`}
                        >
                            <div className={styles.headWorldIcon}>
                                <Image
                                    src="/custom-icons/home-custom/italy-hand.svg"
                                    alt="italy-hand"
                                    width={33}
                                    height={37}
                                    style={{ objectFit: "contain" }}
                                />
                            </div>
                            <h4>Italian Expertise</h4>
                            <p className="mb-0">
                                You will receive a{" "}
                                <strong>
                                    guided tour by
                                    <br />
                                    someone who loves
                                </strong>
                                , lives and
                                <br />
                                breathes this country.
                            </p>
                        </div>
                    </MDBCol>
                    <MDBCol size={12} md={4} className="px-4 px-lg-5">
                        <div
                            className={`d-flex flex-column align-items-center text-center ${styles.headCardContent}`}
                        >
                            <div className={styles.headWorldIcon}>
                                <Italy alt="italy" />
                            </div>
                            <h4>
                                Discover Italy
                                <br />
                                in a Premium Way
                            </h4>
                            <p className="mb-0">
                                Seamless{" "}
                                <strong>
                                    private transfers,
                                    <br /> handpicked accommodations,
                                    <br /> curated experiences.
                                </strong>
                            </p>
                        </div>
                    </MDBCol>
                    <MDBCol size={12} md={4} className="px-4 px-lg-5">
                        <div
                            className={`d-flex flex-column align-items-center text-center ${styles.headCardContent}`}
                        >
                            <div className={styles.headWorldIcon}>
                                <Image
                                    src="/custom-icons/home-custom/sun.svg"
                                    alt="sun"
                                    width={46}
                                    height={29}
                                    style={{ objectFit: "contain" }}
                                />
                            </div>
                            <h4>Crafted for You</h4>
                            <p className="mb-0">
                                Let us craft a{" "}
                                <strong>
                                    {" "}
                                    bespoke itinerary <br /> inspired by your
                                    travel dreams,{" "}
                                </strong>{" "}
                                or <br /> explore our curated selection.
                            </p>
                        </div>
                    </MDBCol>
                </MDBRow>
            </MDBCol>
        </MDBRow>
    );
};

export default HomeHeadDetailDesktop;
